import { Button, ButtonVariant, Icon, Size } from "@blueprintjs/core"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"

export const LayerHeader = (): JSX.Element => {
    const { isLayersTread }     = useLandingConsoleStore( (state: ILandingConsoleStore) => state )
    
    const onTread = () => {
        useLandingConsoleStore.setState({ isLayersTread: false, layersPositions: {x: 300, y: 200, w: 280, h:390} })
    }
    return isLayersTread 
        ?
        <div>
            <Button size={ Size.SMALL } variant={ ButtonVariant.MINIMAL } onClick={ onTread }>
                <Icon icon={ "arrow-left" } size={ 11 } color={"#FFFFFF"} />
            </Button>
        </div>
        :
        <></>
}